(() => {
  const normalize = (value = '') => value
    .trim()
    .toLocaleLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/[\[\](){}'“”‘’.,:;!?|/\\-]/g, '');

  const initDescription = (root) => {
    if (!root || root.dataset.jpcDescriptionReady === 'true') return;

    const source = root.querySelector('[data-jpc-description-source]');
    if (!source) return;

    const children = Array.from(source.children);
    if (!children.length) return;

    const productTitle = normalize(root.dataset.productTitle || '');
    const aboutLabel = root.dataset.aboutLabel || 'About the Artwork';
    const groups = [];
    let current = null;

    const pushCurrent = () => {
      if (current && current.nodes.length) groups.push(current);
      current = null;
    };

    children.forEach((node) => {
      if (/^H[2-4]$/.test(node.tagName)) {
        pushCurrent();
        const originalTitle = node.textContent.trim();
        const title = normalize(originalTitle) === productTitle ? aboutLabel : originalTitle;
        current = { title: title || aboutLabel, nodes: [] };
        return;
      }

      if (!current) current = { title: aboutLabel, nodes: [] };
      current.nodes.push(node);
    });

    pushCurrent();
    if (!groups.length) return;

    const accordion = document.createElement('div');
    accordion.className = 'jpc-description-accordion';

    groups.forEach((group, index) => {
      const details = document.createElement('details');
      details.className = 'jpc-description-card';
      if (index === 0) details.open = true;

      const summary = document.createElement('summary');
      const heading = document.createElement('h3');
      heading.className = 'jpc-description-card__title';
      heading.textContent = group.title;

      const icon = document.createElement('span');
      icon.className = 'jpc-description-card__icon';
      icon.setAttribute('aria-hidden', 'true');

      const content = document.createElement('div');
      content.className = 'jpc-description-card__content rte';
      group.nodes.forEach((node) => content.appendChild(node));

      summary.append(heading, icon);
      details.append(summary, content);

      details.addEventListener('toggle', () => {
        if (!details.open) return;
        accordion.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });

      accordion.appendChild(details);
    });

    source.replaceWith(accordion);
    root.dataset.jpcDescriptionReady = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-jpc-description]').forEach(initDescription);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
